(function () {
    "use strict";

    angular
        .module("App", ["ngRoute", "ngAnimate", "ngSanitize", "ui.bootstrap", "ui.validate", "pascalprecht.translate", "tmh.dynamicLocale", "treasure-overlay-spinner"]);

    angular
        .module("App")
        .config(config)
        .run(run);

    config.$inject = ["$routeProvider", "$httpProvider", "$translateProvider", "tmhDynamicLocaleProvider", "$logProvider"];
    function config($routeProvider, $httpProvider, $translateProvider, tmhDynamicLocaleProvider, $logProvider) {
        // Instellen of debug-logging getoond wordt
        $logProvider.debugEnabled(false);

        $routeProvider
            .when("/login", {
                templateUrl: "components/login/login.html",
                controller: "LoginCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: false
                }
            })
            .when("/resetpassword", {
                templateUrl: "components/password/reset-password.html",
                controller: "ResetPasswordCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: false
                }
            })
            .when("/changepassword", {
                templateUrl: "components/password/change-password.html",
                controller: "ChangePasswordCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/home", {
                templateUrl: "components/home/home.html",
                controller: "HomeCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/stock", {
                templateUrl: "components/stock/stock.html",
                controller: "StockCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/customers/:klantnr/articles/:artikelnr/batches/:partijnr/stock", {
                templateUrl: "components/stock-detail/stock-detail.html",
                controller: "StockDetailCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/block-stock", {
                templateUrl: "components/block-stock/block-stock.html",
                controller: "BlockStockCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/stocktrail", {
                templateUrl: "components/stock-trail/stock-trail.html",
                controller: "StockTrailCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/nightstand", {
                templateUrl: "components/nightstand/nightstand.html",
                controller: "NightstandCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/articles", {
                templateUrl: "components/article/article.html",
                controller: "ArticleCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/receipts", {
                templateUrl: "components/receipt/receipt.html",
                controller: "ReceiptCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/customers/:klantnr/receipts/:ontvangstnr", {
                templateUrl: "components/receipt-detail/receipt-detail.html",
                controller: "ReceiptDetailCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/orders", {
                templateUrl: "components/order/order.html",
                controller: "OrderCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/customers/:klantnr/orders/:ordernr/suborders/:volgnr", {
                templateUrl: "components/order-detail/order-detail.html",
                controller: "OrderDetailCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/dpus", {
                templateUrl: "components/dpu/dpu.html",
                controller: "DpuCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/dpus/:dpunr", {
                templateUrl: "components/dpu-detail/dpu-detail.html",
                controller: "DpuDetailCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .when("/recall", {
                templateUrl: "components/recall/recall.html",
                controller: "RecallCtrl",
                controllerAs: "vm",
                data: {
                    authenticate: true
                }
            })
            .otherwise({
                redirectTo: "/login"
            });

        $httpProvider.interceptors.push("AuthInterceptor");
        $httpProvider.defaults.headers.common["Pragma"] = "no-cache"; // Voorkomt dat IE 11 cache gebruikt voor GET

        $translateProvider.useSanitizeValueStrategy("escape"); // LET OP: Hiermee wordt XSS aanval voorkomen!
        tmhDynamicLocaleProvider.localeLocationPattern("js/angular-locale_{{locale}}.js"); // Stelt in waar de vertalingen voor de datepicker staan
    }

    run.$inject = ["$log", "$rootScope", "$translate", "lowercaseFilter", "tmhDynamicLocale", "SessionService", "AuthService", "ConfigService"];
    function run($log, $rootScope, $translate, lowercaseFilter, tmhDynamicLocale, SessionService, AuthService, ConfigService) {
        // Stelt taal in 
        let lang = SessionService.getLanguage() || "NL"; 
        $translate.use(lang);
        tmhDynamicLocale.set(lowercaseFilter(lang));

        // Controleert of gebruiker is ingelogd bij navigatie
        $rootScope.global = {};
        $rootScope.$on("$routeChangeStart", (event, next) => {
            if (next.data && next.data.authenticate && !AuthService.isAuthenticated()) {
                $log.debug("User is not authenticated.");
                event.preventDefault();
                // TODO: Emit 'notAuthorized' event en/of navigeer naar loginscherm.
            }
        })
    }
})();;
// https://gist.github.com/mlynch/dd407b93ed288d499778
(function () {
    "use strict";

    angular
        .module("App")
        .directive("autofocus", Autofocus);

    Autofocus.$inject = ["$log", "$timeout"];
    function Autofocus($log, $timeout) {
        let directive = { // NOTE: Geen isolated scope gebruiken omdat een element meerdere attribuut-directives kan bevatten.
            restrict: "A",
            link: link
        };

        initialize();

        return directive;

        function initialize() {
            $log.debug("Initialize Autofocus");
        }

        function link(scope, elem) {
            $timeout(() => {
                elem[0].focus();
            });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .filter("vbNonzero", vbNonzero);

    vbNonzero.$inject = ["$log"];
    function vbNonzero($log) {
        initialize();

        return filter;

        function initialize() {
            $log.debug("Initialize vbNonzero");
        }

        // Vervangt waarde 0 door een lege string
        function filter(input) {
            if (input === 0 || input === "0") {
                return "";
            } else {
                return input;
            }
        }
    }

})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("ArticleCtrl", ArticleCtrl);
    
    ArticleCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "ArticleService", "CustomerService"];
    function ArticleCtrl($log, $scope, $location, $routeParams, ArticleService, CustomerService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;

        vm.customers = CustomerService.getCustomers();
        vm.articles = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "klantnr";
        vm.orderBy = orderBy;

        // Zoeken
        vm.selCustomerId = Number($routeParams.klantnr) || (vm.customers.length > 0 ? vm.customers[0].klantnr : null);
        vm.selArticleId = $routeParams.artikelnr || null;
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;

        function activate() {
            $log.debug("Activate ArticleCtrl");
            query();
        }

        function closeAlert() {
            vm.alert = null;
        }

        function query() {
            let params = {};
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            ArticleService
                .findAll(params)
                .then((res) => {
                    vm.articles = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("klantnr", vm.selCustomerId ? vm.selCustomerId : null);
            $location.search("artikelnr", vm.selArticleId ? vm.selArticleId : null);
            query();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            query();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            query();
        }

        function refresh() {
            query();
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            ArticleService.findAll(params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "artikelen.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("ArticleService", ArticleService);
    
    ArticleService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function ArticleService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize ArticleService");
        }

        function findAll(params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/artikelen`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Articles found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("AuthService", AuthService);
    
    AuthService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function AuthService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            login: login,
            logout: logout,
            changePassword: changePassword,
            resetPassword: resetPassword,
            isAuthenticated: isAuthenticated
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize AuthService");
        }

        function login(credentials) {
            let url = ConfigService.get("apiUrl") + "/auth";
            return $http
                .post(url, credentials)
                .then((res) => {
                    let token = res.data.token;
                    let username = credentials.username;
                    $log.debug(`User '${username}' authenticated with token '${token}'`);
                    SessionService.create({ token: token, username:username });
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "Invalid username or password";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }

        function logout() {
            let token = SessionService.getToken();
            let url = ConfigService.get("apiUrl") + `/auth/${token}`;
            return $http
                .delete(url)
                .then(() => {
                    SessionService.destroy();
                    $log.debug(`User logged out`);
                })
                .catch((err) => {
                    SessionService.destroy();
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "Cannot logoff";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data)
                });
        }

        function changePassword(data) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/auth/${username}`;
            return $http 
                .put(url, data)
                .then((res) => {
                    $log.debug("Password changed");
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "Cannot change password"
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }

        function resetPassword(username){ 
            let url = ConfigService.get("apiUrl") + `/users/${username}/password`;
            return $http 
                .post(url)
                .then((res) => {
                    $log.debug("Password restored");
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "Cannot restore password"
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                })
        }

        function isAuthenticated() {
            return !!SessionService.getToken();
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("AuthInterceptor", AuthInterceptor);
    
    AuthInterceptor.$inject = ["$log", "SessionService"];
    function AuthInterceptor($log, SessionService) {
        let service = {
            request: request
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize AuthInterceptor");
        }

        function request(config) {
            $log.debug("Intercepted request");
            let token = SessionService.getToken();
            if (token) {
                config.headers["Authorization"] = `Vanboxtel ${token}`;
            }
            return config;
        }
    }
})();;
(function() {
    "use strict";

    angular 
        .module("App")
        .controller("BlockResultCtrl", BlockResultCtrl);
    
    BlockResultCtrl.$inject = ["$log", "$uibModalInstance"];
    function BlockResultCtrl($log, $uibModalInstance) {
        let vm = this;

        vm.data = $uibModalInstance.data;

        vm.close = close;

        function activate() {
            $log.debug("Activate BlockResultCtrl");
        }

        function close() {
            $uibModalInstance.close();
        }

        activate();
    }
})();
;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("BlockStockCtrl", BlockStockCtrl);
    
    BlockStockCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "BlockStockService", "CustomerService", "$uibModal"];
    function BlockStockCtrl($log, $scope, $location, $routeParams, BlockStockService, CustomerService, $uibModal) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;

        vm.customers = CustomerService.getCustomers();
        vm.stock = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "lotcode";
        vm.orderBy = orderBy;

        // Zoeken
        vm.selCustomerId = Number($routeParams.klantnr) || (vm.customers.length > 0 ? vm.customers[0].klantnr : null);
        vm.selArticleId = $routeParams.artikelnr || null;
        vm.selSSCC = $routeParams.ssccnr || null;
        vm.selLotcode = $routeParams.lotcode || null;
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;
        vm.setChanged = setChanged;
        vm.selectionsChanged = false;

        // Acties
        vm.block = block;
        vm.unblock = unblock;
        vm.actionsEnabled = actionsEnabled;

        function activate() {
            $log.debug("Activate BlockStockCtrl");
            query();
        }

        function closeAlert() {
            vm.alert = null;
        }

        function query() {
            let params = {};
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            if (vm.selSSCC) {
                params.ssccnr = vm.selSSCC;
            }
            if (vm.selLotcode) {
                params.lotcode = vm.selLotcode;
            }
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            BlockStockService
                .findAll(params)
                .then((res) => {
                    vm.stock = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.selectionsChanged = false;
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.selectionsChanged = true;
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("klantnr", vm.selCustomerId ? vm.selCustomerId : null);
            $location.search("artikelnr", vm.selArticleId ? vm.selArticleId : null);
            $location.search("ssccnr", vm.selSSCC ? vm.selSSCC : null);
            $location.search("lotcode", vm.selLotcode ? vm.selLotcode : null);
            query();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            query();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            query();
        }

        function refresh() {
            query();
        }

        function setChanged() {
            vm.selectionsChanged = true;
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            if (vm.selSSCC) {
                params.ssccnr = vm.selSSCC;
            }
            if (vm.selLotcode) {
                params.lotcode = vm.selLotcode;
            }
            BlockStockService.findAll(params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "voorraad.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function block() {
            let data = {
                blokkeren_jn: "J"
            };
            if (vm.selCustomerId) {
                data.klantnr = vm.selCustomerId;
            }
            if (vm.selSSCC) {
                data.ssccnr = vm.selSSCC;
            }
            if (vm.selLotcode) {
                data.lotcode = vm.selLotcode;
            }
            if (vm.selArticleId) {
                data.artikelnr = vm.selArticleId;
            }
            changeStock(data);
        }

        function unblock() {
            let data = {
                blokkeren_jn: "N"
            };
            if (vm.selCustomerId) {
                data.klantnr = vm.selCustomerId;
            }
            if (vm.selSSCC) {
                data.ssccnr = vm.selSSCC;
            }
            if (vm.selLotcode) {
                data.lotcode = vm.selLotcode;
            }
            if (vm.selArticleId) {
                data.artikelnr = vm.selArticleId;
            }
            changeStock(data);
        }

        function changeStock(data) {
            vm.loading = true;
            BlockStockService.update(data)
                .then((res) => {
                    vm.loading = false;
                    // Show modal
                    let modalInstance = $uibModal.open({
                        animation: false,
                        templateUrl: "components/block-stock/block-result.html",
                        controller: "BlockResultCtrl",
                        controllerAs: "vm",
                        backdrop: "static",
                        size: "lg"
                    });
                    modalInstance.data = res.data;
                    modalInstance.result 
                        .then((res) => {
                            // Filters leeg maken
                            $location.search({});
                            console.log("hoi")
                        });
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function actionsEnabled() {
            return !vm.selectionsChanged && (vm.selSSCC || vm.selLotcode);
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("BlockStockService", BlockStockService);
    
    BlockStockService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function BlockStockService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            findAll: findAll,
            update: update
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize BlockStockService");
        }

        function findAll(params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/voorraad-blok`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Stock found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }

        function update(data) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/voorraad-blok`;
            return $http 
                .put(url, data)
                .then((res) => {
                    $log.debug("Stock (un)blocked");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                })
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("ConfigService", ConfigService);
    
    ConfigService.$inject = ["$log", "$http", "$q"];
    function ConfigService($log, $http, $q) {
        let service = {
            get: get
        };

        let values = {};

        initialize();

        return service;

        function initialize() {
            // TODO: Andere services/controllers moeten wachten totdat de configuratie gelezen is.
            $log.debug("Initialize ConfigService");
            $http 
                .get("config/config.json")
                .then((res) => {
                    $log.debug("Configuration loaded");
                    values = res.data;
                })
                .catch((err) => {
                    $log.error(err);
                    return $q.reject("Cannot load configuration");
                })
        }

        function get(key) {
            let value = values;
            key.split(".").forEach((name) => {
                value = value[name];
                if (typeof value === "undefined") {
                    $log.warn(`Unknown configuration key '${key}'`);
                    return;
                }
            });
            return value;
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("CustomerService", CustomerService);
    
    CustomerService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function CustomerService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            find: find,
            getCustomers: getCustomers
        };

        let customers = [];

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize CustomerService");

            customers = JSON.parse(sessionStorage.getItem("customers"));
        }

        function find() {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/klanten`;
            return $http
                .get(url)
                .then((res) => {
                    $log.debug("Customers found");
                    customers = res.data;
                    try {
                        sessionStorage.setItem("customers", JSON.stringify(customers));
                    } catch (err) {
                        $log.error(err);
                    }
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "Invalid username";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }

        function getCustomers() {
            return customers;
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("DpuDetailCtrl", DpuDetailCtrl);
    
    DpuDetailCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "DpuService", "DpuDetailService"];
    function DpuDetailCtrl($log, $scope, $location, $routeParams, DpuService, DpuDetailService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;

        vm.dpuId = Number($routeParams.dpunr);
        vm.dpu = null;
        vm.dpuDetails = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "artikelnr";
        vm.orderBy = orderBy;

        // Zoeken
        vm.refresh = refresh;
        vm.download = download;
        vm.typeOptions = [
            {
                id: "C",
                description: "Collipicken"
            }, {
                id: "L",
                description: "Lagenpick"
            }, {
                id: "V",
                description: "Volle pallet"
            }
        ];

        function activate() {
            $log.debug("Activate DpuDetailCtrl");
            queryDPU()
                .then(() => {
                    queryDetails();
                });
        }

        function closeAlert() {
            vm.alert = null;
        }

        function queryDPU() {
            vm.loading = true;
            return DpuService 
                .find(vm.dpuId)
                .then((res) => {
                    vm.dpu = res.data;
                    if (vm.dpu.klantnr && vm.dpu.klantnaam) {
                        vm.dpu.klant = vm.dpu.klantnr + " - " + vm.dpu.klantnaam;
                    } else {
                        vm.dpu.klant = "" + vm.dpu.klantnr + vm.dpu.klantnaam;
                    }
                    if (vm.dpu.artikelnr && vm.dpu.artikelomschrijving) {
                        vm.dpu.artikel = vm.dpu.artikelnr + " - " + vm.dpu.artikelomschrijving;
                    } else {
                        vm.dpu.artikel = "" + vm.dpu.artikelnr + vm.dpu.artikelomschrijving;
                    }
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                })
        }

        function queryDetails() {
            let params = {};
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            return DpuDetailService
                .findAll(vm.dpuId, params)
                .then((res) => {
                    vm.dpuDetails = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            queryDetails();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            queryDetails();
        }

        function refresh() {
            queryDPU()
                .then(() => {
                    queryDetails();
                });
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            DpuDetailService.findAll(vm.dpuId, params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "dpudetails.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("DpuDetailService", DpuDetailService);
    
    DpuDetailService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function DpuDetailService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize DpuDetailService");
        }

        function findAll(dpuId, params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/dpus/${dpuId}/details`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Dpu details found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("DpuCtrl", DpuCtrl);
    
    DpuCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "OrderService", "DpuService"];
    function DpuCtrl($log, $scope, $location, $routeParams, OrderService, DpuService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;
        vm.clickItem = clickItem;

        vm.customerId = Number($routeParams.klantnr);
        vm.orderId = Number($routeParams.ordernr);
        vm.suborderId = Number($routeParams.volgnr);
        vm.order = null;
        vm.dpus = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "dpunr";
        vm.orderBy = orderBy;

        // Zoeken
        vm.refresh = refresh;
        vm.download = download;
        vm.statusOptions = [
            {
                id: "I",
                description: "Initieel"
            }, {
                id: "A",
                description: "Actief"
            }, {
                id: "G",
                description: "Geselecteerd"
            }, {
                id: "D",
                description: "Deels vrijgegeven"
            }, {
                id: "O",
                description: "Vrijgegeven voor picking"
            }, {
                id: "B",
                description: "Bevestigd"
            }, {
                id: "V",
                description: "Vrachtbrief geprint"
            }, {
                id: "R",
                description: "Vrachtbrief afgemeld"
            }, {
                id: "Z",
                description: "Geannuleerd"
            }
        ];
        vm.typeOptions = [
            {
                id: "C",
                description: "Collipicken"
            }, {
                id: "L",
                description: "Lagenpick"
            }, {
                id: "V",
                description: "Volle pallet"
            }
        ];

        function activate() {
            $log.debug("Activate DpuCtrl");
            queryOrder()
                .then(() => {
                    queryDetails();
                });
        }

        function clickItem(index) {
            let dpuId = vm.dpus[index].dpunr;
            $location
                .path(`/dpus/${dpuId}`)
                .search({});
        }

        function closeAlert() {
            vm.alert = null;
        }

        function queryOrder() {
            vm.loading = true;
            return OrderService 
                .find(vm.customerId, vm.orderId, vm.suborderId)
                .then((res) => {
                    vm.order = res.data;
                    if (vm.order.klantnr && vm.order.klantnaam) {
                        vm.order.klant = vm.order.klantnr + " - " + vm.order.klantnaam;
                    } else {
                        vm.order.klant = "" + vm.order.klantnr + vm.order.klantnaam;
                    }
                    if (vm.order.aflevernr && vm.order.aflevernaam) {
                        vm.order.afleveradres = vm.order.aflevernr + " - " + vm.order.aflevernaam;
                    } else {
                        vm.order.afleveradres = "" + vm.order.aflevernr + vm.order.aflevernaam;
                    }
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                })
        }

        function queryDetails() {
            let params = {};
            if (vm.customerId) {
                params.klantnr = vm.customerId;
            }
            if (vm.orderId) {
                params.ordernr = vm.orderId;
            }
            if (vm.suborderId) {
                params.volgnr = vm.suborderId;
            }
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            DpuService
                .findAll(params)
                .then((res) => {
                    vm.dpus = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            queryDetails();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            queryDetails();
        }

        function refresh() {
            queryOrder()
                .then(() => {
                    queryDetails();
                });
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            if (vm.customerId) {
                params.klantnr = vm.customerId;
            }
            if (vm.orderId) {
                params.ordernr = vm.orderId;
            }
            if (vm.suborderId) {
                params.volgnr = vm.suborderId;
            }
            DpuService.findAll(params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "dpus.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("DpuService", DpuService);
    
    DpuService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function DpuService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            find: find,
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize DpuService");
        }

        function find(dpuId) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/dpus/${dpuId}`;
            return $http 
                .get(url)
                .then((res) => {
                    $log.debug("DPU found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }

        function findAll(params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/dpus`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("DPUs found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    // Directive voor header.
    angular
        .module("App")
        .directive("headerNavbar", headerNavbar);

    function headerNavbar() {
        return {
            restrict: "E",
            replace: true,
            transculed: true,
            controller: "HeaderCtrl",
            controllerAs: "vm",
            templateUrl: "components/header/header.html"
        }
    };

    // Controller voor header.
    angular
        .module("App")
        .controller("HeaderCtrl", HeaderCtrl);

    HeaderCtrl.$inject = ["$log", "$location", "AuthService", "SessionService"];
    function HeaderCtrl($log, $location, AuthService, SessionService) {
        let vm = this;

        vm.isNavCollapsed = true;
        vm.getUsername = getUsername;

        vm.logout = logout;
        vm.isLoggedIn = isLoggedIn;
        
        function activate() {
            $log.debug("Activate HeaderCtrl");
        }

        function isActive(path) {
            return $location.path().substr(0, path.length) === path;
        }

        function logout() {
            AuthService.logout();
        }

        function isLoggedIn() {
            return AuthService.isAuthenticated();
        }

        function getUsername() {
            return SessionService.getUsername();
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("HomeCtrl", HomeCtrl);
    
    HomeCtrl.$inject = ["$log", "SessionService"];
    function HomeCtrl($log, SessionService) {
        let vm = this;

        vm.name = SessionService.getFullName();

        function activate() {
            $log.debug("Activate HomeCtrl");
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("LoginCtrl", LoginCtrl);
    
    LoginCtrl.$inject = ["$log", "$location", "$translate", "tmhDynamicLocale", "lowercaseFilter", "SessionService", "ConfigService", "AuthService", "SettingsService", "CustomerService"];
    function LoginCtrl($log, $location, $translate, tmhDynamicLocale, lowercaseFilter, SessionService, ConfigService, AuthService, SettingsService, CustomerService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;

        vm.username = null;
        vm.password = null;
        vm.submit = submit;
        vm.pathToLogo = ConfigService.get("pathToLogo") || "media/images/Vanboxtel.png";

        function activate() {
            $log.debug("Activate LoginCtrl");
        }

        function closeAlert() {
            vm.alert = null;
        }

        function submit(valid) {
            if (valid) {
                let credentials = { username: vm.username, password: vm.password };
                vm.loading = true;
                AuthService
                    .login(credentials)
                    .then(() => {
                        SettingsService
                            .find()
                            .then((res) => {
                                $translate.use(res.data.taalcode);
                                tmhDynamicLocale.set(lowercaseFilter(res.data.taalcode));
                                SessionService.setFullName(res.data.naam);
                                SessionService.setLanguage(res.data.taalcode);
                                CustomerService 
                                    .find()
                                    .then(() => {
                                        vm.loading = false;
                                        $location.path("/home");
                                    })
                                    .catch((err) => {
                                        vm.loading = false;
                                        vm.alert = {type: "danger", msg: err.errorText};
                                    });
                            })
                            .catch((err) => {
                                AuthService.logout()
                                .then(() => {
                                        vm.loading = false;
                                    })
                                    .catch((err) => {
                                        vm.loading = false;
                                    });
                                vm.alert = {type: "danger", msg: err.errorText};
                            });
                    })
                    .catch((err) => {
                        vm.loading = false;
                        vm.alert = { type: "danger", msg: err.errorText };
                    });
            }
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("NightstandCtrl", NightstandCtrl);
    
    NightstandCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "$uibModal", "NightstandService", "CustomerService"];
    function NightstandCtrl($log, $scope, $location, $routeParams, $uibModal, NightstandService, CustomerService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;
        vm.openDatepicker = openDatepicker;

        vm.customers = CustomerService.getCustomers();
        vm.data = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "datum";
        vm.orderBy = orderBy;

        // Zoeken
        vm.selDate = $routeParams.datum ? new Date($routeParams.datum) : new Date();
        vm.selCustomerId = Number($routeParams.klantnr) || (vm.customers.length > 0 ? vm.customers[0].klantnr : null);
        vm.selArticleId = $routeParams.artikelnr || null;
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;

        // Datepicker
        vm.selDateOptions = {
            startingDay: 1
        };
        vm.selDateFormat = "dd-MM-yyyy";
        vm.altInputFormats = ["d!-M!-yyyy"];
        vm.selDateStatus = { opened: false };

        function activate() {
            $log.debug("Activate NightstandCtrl");
            query();
        }

        function openDatepicker(id) {
            switch (id) {
                case "datum":
                    vm.selDateStatus.opened = true;
                    break;
                default:
                    $log.error(`Unknown datepicker '${id}'`);
            }
        }

        function closeAlert() {
            vm.alert = null;
        }

        function query() {
            let params = {};
            if (vm.selDate) {
                let year = vm.selDate.getFullYear();
                let month = vm.selDate.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDate.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.datum = year + "-" + month + "-" + day;
            }
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            NightstandService
                .findAll(params)
                .then((res) => {
                    vm.data = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("klantnr", vm.selCustomerId ? vm.selCustomerId : null);
            $location.search("artikelnr", vm.selArticleId ? vm.selArticleId : null);
            if (vm.selDate) {
                let year = vm.selDate.getFullYear();
                let month = vm.selDate.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDate.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                $location.search("datum", year + "-" + month + "-" + day);
            } else {
                $location.search("datum", null);
            }
            query();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            query();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            query();
        }

        function refresh() {
            query();
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            if (vm.selDate) {
                let year = vm.selDate.getFullYear();
                let month = vm.selDate.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDate.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.datum = year + "-" + month + "-" + day;
            }
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            NightstandService.findAll(params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "nachtstand.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("NightstandService", NightstandService);
    
    NightstandService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function NightstandService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize NightstandService");
        }

        function findAll(params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/nachtstand`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Nightstand found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("OrderDetailCtrl", OrderDetailCtrl);
    
    OrderDetailCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "OrderService", "OrderDetailService"];
    function OrderDetailCtrl($log, $scope, $location, $routeParams, OrderService, OrderDetailService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;
        vm.clickItem = clickItem;

        vm.customerId = Number($routeParams.klantnr);
        vm.orderId = Number($routeParams.ordernr);
        vm.suborderId = Number($routeParams.volgnr);
        vm.order = null;
        vm.orderDetails = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "artikelnr";
        vm.orderBy = orderBy;

        // Zoeken
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;
        vm.statusOptions = [
            {
                id: "I",
                description: "Initieel"
            }, {
                id: "A",
                description: "Actief"
            }, {
                id: "G",
                description: "Geselecteerd"
            }, {
                id: "D",
                description: "Deels vrijgegeven"
            }, {
                id: "O",
                description: "Vrijgegeven voor picking"
            }, {
                id: "B",
                description: "Bevestigd"
            }, {
                id: "V",
                description: "Vrachtbrief geprint"
            }, {
                id: "R",
                description: "Vrachtbrief afgemeld"
            }, {
                id: "Z",
                description: "Geannuleerd"
            }
        ];

        function activate() {
            $log.debug("Activate OrderDetailCtrl");
            queryOrder()
                .then(() => {
                    queryDetails();
                });
        }

        function clickItem() {
            let customerId = vm.customerId;
            let orderId = vm.orderId;
            let suborderId = vm.suborderId;
            $location
                .path("/dpus")
                .search({
                    klantnr: customerId,
                    ordernr: orderId,
                    volgnr: suborderId
                });
        }

        function closeAlert() {
            vm.alert = null;
        }

        function queryOrder() {
            vm.loading = true;
            return OrderService 
                .find(vm.customerId, vm.orderId, vm.suborderId)
                .then((res) => {
                    vm.order = res.data;
                    if (vm.order.klantnr && vm.order.klantnaam) {
                        vm.order.klant = vm.order.klantnr + " - " + vm.order.klantnaam;
                    } else {
                        vm.order.klant = "" + vm.order.klantnr + vm.order.klantnaam;
                    }
                    if (vm.order.aflevernr && vm.order.aflevernaam) {
                        vm.order.afleveradres = vm.order.aflevernr + " - " + vm.order.aflevernaam;
                    } else {
                        vm.order.afleveradres = "" + vm.order.aflevernr + vm.order.aflevernaam;
                    }
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                })
        }

        function queryDetails() {
            let params = {};
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            return OrderDetailService
                .findAll(vm.customerId, vm.orderId, vm.suborderId, params)
                .then((res) => {
                    vm.orderDetails = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            queryDetails();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            queryDetails();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            queryDetails();
        }

        function refresh() {
            queryOrder()
                .then(() => {
                    queryDetails();
                });
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            OrderDetailService.findAll(vm.customerId, vm.orderId, vm.suborderId, params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "orderdetails.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("OrderDetailService", OrderDetailService);
    
    OrderDetailService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function OrderDetailService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize OrderDetailService");
        }

        function findAll(customerId, orderId, suborderId, params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/klanten/${customerId}/orders/${orderId}/suborders/${suborderId}/details`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Order details found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("OrderCtrl", OrderCtrl);
    
    OrderCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "OrderService", "CustomerService"];
    function OrderCtrl($log, $scope, $location, $routeParams, OrderService, CustomerService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;
        vm.openDatepicker = openDatepicker;
        vm.clickItem = clickItem;

        vm.customers = CustomerService.getCustomers();
        vm.orders = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "klantnr";
        vm.orderBy = orderBy;

        // Zoeken
        vm.selCustomerId = Number($routeParams.klantnr) || (vm.customers.length > 0 ? vm.customers[0].klantnr : null);
        vm.selOrderRef = $routeParams.orderref || null;
        vm.selStatusFrom = $routeParams.status_van || "I";
        vm.selStatusTo = $routeParams.status_tm || "Z";
        vm.selDeliveryId = $routeParams.aflevernr || null;
        vm.selDeliveryDateFrom = $routeParams.afleverdatum_van ? new Date($routeParams.afleverdatum_van) : new Date();
        vm.selDeliveryDateTo = $routeParams.afleverdatum_tm ? new Date($routeParams.afleverdatum_tm) : new Date();
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;
        vm.statusOptions = [
            {
                id: "I",
                description: "Initieel"
            }, {
                id: "A",
                description: "Actief"
            }, {
                id: "G",
                description: "Geselecteerd"
            }, {
                id: "D",
                description: "Deels vrijgegeven"
            }, {
                id: "O",
                description: "Vrijgegeven voor picking"
            }, {
                id: "B",
                description: "Bevestigd"
            }, {
                id: "V",
                description: "Vrachtbrief geprint"
            }, {
                id: "R",
                description: "Vrachtbrief afgemeld"
            }, {
                id: "Z",
                description: "Geannuleerd"
            }
        ];

        // Datepicker
        vm.selDateOptions = {
            startingDay: 1
        };
        vm.selDateFormat = "dd-MM-yyyy";
        vm.altInputFormats = ["d!-M!-yyyy"];
        vm.selDeliveryDateFromStatus = { opened: false };
        vm.selDeliveryDateToStatus = { opened: false };

        function activate() {
            $log.debug("Activate OrderCtrl");
            query();
        }

        function openDatepicker(id) {
            switch (id) {
                case "afleverdatum-van":
                    vm.selDeliveryDateFromStatus.opened = true;
                    break;
                case "afleverdatum-tm":
                    vm.selDeliveryDateToStatus.opened = true;
                    break;
                default:
                    $log.error(`Unknown datepicker '${id}'`);
            }
        }

        function clickItem(index) {
            let customerId = vm.orders[index].klantnr;
            let orderId = vm.orders[index].ordernr;
            let suborderId = vm.orders[index].volgnr;
            $location
                .path(`/customers/${customerId}/orders/${orderId}/suborders/${suborderId}`)
                .search({});
        }

        function closeAlert() {
            vm.alert = null;
        }

        function query() {
            let params = {};
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selOrderRef) {
                params.order_referentie = vm.selOrderRef;
            }
            if (vm.selStatusFrom) {
                params.status_van = vm.selStatusFrom;
            }
            if (vm.selStatusTo) {
                params.status_tm = vm.selStatusTo;
            }
            if (vm.selDeliveryId) {
                params.aflevernr = vm.selDeliveryId;
            }
            if (vm.selDeliveryDateFrom) {
                let year = vm.selDeliveryDateFrom.getFullYear();
                let month = vm.selDeliveryDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.afleverdatum_van = year + "-" + month + "-" + day;
            }
            if (vm.selDeliveryDateTo) {
                let year = vm.selDeliveryDateTo.getFullYear();
                let month = vm.selDeliveryDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.afleverdatum_tm = year + "-" + month + "-" + day;
            }
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            OrderService
                .findAll(params)
                .then((res) => {
                    vm.orders = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("klantnr", vm.selCustomerId || null);
            $location.search("orderref", vm.selOrderRef || null);
            $location.search("status_van", vm.selStatusFrom || null);
            $location.search("status_tm", vm.selStatusTo || null);
            $location.search("aflevernr", vm.selDeliveryId || null);
            if (vm.selDeliveryDateFrom) {
                let year = vm.selDeliveryDateFrom.getFullYear();
                let month = vm.selDeliveryDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                $location.search("afleverdatum_van", year + "-" + month + "-" + day);
            } else {
                $location.search("afleverdatum_van", null);
            }
            if (vm.selDeliveryDateTo) {
                let year = vm.selDeliveryDateTo.getFullYear();
                let month = vm.selDeliveryDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                $location.search("afleverdatum_tm", year + "-" + month + "-" + day);
            } else {
                $location.search("afleverdatum_tm", null);
            }
            query();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            query();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            query();
        }

        function refresh() {
            query();
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selOrderRef) {
                params.order_referentie = vm.selOrderRef;
            }
            if (vm.selStatusFrom) {
                params.status_van = vm.selStatusFrom;
            }
            if (vm.selStatusTo) {
                params.status_tm = vm.selStatusTo;
            }
            if (vm.selDeliveryId) {
                params.aflevernr = vm.selDeliveryId;
            }
            if (vm.selDeliveryDateFrom) {
                let year = vm.selDeliveryDateFrom.getFullYear();
                let month = vm.selDeliveryDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.afleverdatum_van = year + "-" + month + "-" + day;
            }
            if (vm.selDeliveryDateTo) {
                let year = vm.selDeliveryDateTo.getFullYear();
                let month = vm.selDeliveryDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.afleverdatum_tm = year + "-" + month + "-" + day;
            }
            OrderService.findAll(params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "orders.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("OrderService", OrderService);
    
    OrderService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function OrderService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            find: find,
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize OrderService");
        }

        function find(customerId, orderId, suborderId) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/klanten/${customerId}/orders/${orderId}/suborders/${suborderId}`;
            return $http 
                .get(url)
                .then((res) => {
                    $log.debug("Order found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }

        function findAll(params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/orders`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Orders found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("ChangePasswordCtrl", ChangePasswordCtrl);

    ChangePasswordCtrl.$inject = ["$log", "$location", "$window", "AuthService"];
    function ChangePasswordCtrl($log, $location, $window, AuthService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.submit = submit;
        vm.goback = goback;
        vm.checkRepeatPassword = checkRepeatPassword;
        vm.loading = false;

        vm.oldPassword = null;
        vm.newPassword = null;
        vm.repeatPassword = null;

        function activate() {
            $log.debug("Activate ChangePasswordCtrl");
        }

        function closeAlert() {
            vm.alert = null;
        }

        function goback() {
            $window.history.back();
        }

        function submit(valid) {
            if (valid) {
                let credentials = { old_password: vm.oldPassword, new_password: vm.newPassword };
                vm.loading = true;
                AuthService
                    .changePassword(credentials)
                    .then((res) => {
                        vm.loading = false;
                        $location.path("/home");
                    })
                    .catch((err) => {
                        vm.loading = false;
                        vm.alert = {type: "danger", msg: err.errorText};
                    });
            }
        }

        function checkRepeatPassword(value) {
            return value === vm.newPassword;
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("ResetMessageCtrl", ResetMessageCtrl);
    
    ResetMessageCtrl.$inject = ["$log", "$uibModalInstance"];
    function ResetMessageCtrl($log, $uibModalInstance) {
        let vm = this;
        vm.submit = submit;

        function activate() {
            $log.debug("Activate ResetMessageCtrl");
        }

        function submit() {
            $uibModalInstance.close()
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("ResetPasswordCtrl", ResetPasswordCtrl);

    ResetPasswordCtrl.$inject = ["$log", "$location", "$uibModal", "AuthService"];
    function ResetPasswordCtrl($log, $location, $uibModal, AuthService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.submit = submit;
        vm.goback = goback;
        vm.checkRepeatPassword = checkRepeatPassword;
        vm.loading = false;

        vm.username = null;

        function activate() {
            $log.debug("Activate ResetPasswordCtrl");
        }

        function closeAlert() {
            vm.alert = null;
        }

        function goback() {
            $location.path("/login");
        }

        function submit(valid) {
            if (valid) {
                vm.loading = true;
                AuthService
                    .resetPassword(vm.username)
                    .then((res) => {
                        vm.loading = false;
                        let modalInstance = $uibModal.open({
                            animation: false,
                            templateUrl: "components/password/reset-message.html",
                            controller: "ResetMessageCtrl",
                            controllerAs: "vm",
                            backdrop: "static"
                        });
                        modalInstance
                            .result
                            .then(() => {
                                $location.path("/login");
                            })
                    })
                    .catch((err) => {
                        vm.loading = false;
                        vm.alert = {type: "danger", msg: err.errorText};
                    });
            }
        }

        function checkRepeatPassword(value) {
            return value === vm.newPassword;
        }

        activate();
    }
})();;
(function () {
  "use strict";

  angular
    .module("App")
    .controller("RecallCtrl", RecallCtrl);

  RecallCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "RecallService", "CustomerService"];
  function RecallCtrl($log, $scope, $location, $routeParams, RecallService, CustomerService) {
    let vm = this;

    vm.alert = null;
    vm.closeAlert = closeAlert;
    vm.loading = false;
    vm.openDatepicker = openDatepicker;

    vm.customers = CustomerService.getCustomers();
    vm.articles = null;
    vm.contentRange = {};
    vm.currentPage = Number($routeParams.p) || 1;
    $scope.currentPage = vm.currentPage;
    vm.totalResults = 0;
    vm.changePage = changePage;
    vm.maxItemsPerPage = Number($routeParams.limit) || 20;
    vm.changeItemsPerPage = changeItemsPerPage;
    vm.sort = $routeParams.sort || "datum";
    vm.orderBy = orderBy;

    // Zoeken
    vm.currentParams = {};
    vm.selCustomerId = Number($routeParams.klantnr) || (vm.customers.length > 0 ? vm.customers[0].klantnr : null);
    vm.selArticleId = $routeParams.artikelnr || null;
    vm.selExpiryDate = $routeParams.tht_datum ? new Date($routeParams.tht_datum) : null;
    vm.selSSCC = $routeParams.ssccnr || null;
    vm.selLotcode = $routeParams.lotcode || null;
    vm.selSupplierPalId = $routeParams.palletnr_lev || null;
    vm.selDateFrom = $routeParams.datum_vanaf ? new Date($routeParams.datum_vanaf) : null;
    vm.selDateTo = $routeParams.datum_tm ? new Date($routeParams.datum_tm) : null;
    vm.validateForm = validateForm;
    vm.search = search;
    vm.refresh = refresh;
    vm.download = download;

    // Datepicker
    vm.selDateOptions = {
      startingDay: 1
    };
    vm.selDateFormat = "dd-MM-yyyy";
    vm.altInputFormats = ["d!-M!-yyyy"];
    vm.selExpiryDateStatus = { opened: false };
    vm.selDateFromStatus = { opened: false };
    vm.selDateToStatus = { opened: false };

    function activate() {
      $log.debug("Activate RecallCtrl");
      // Indien artikel opgegeven dan query uitvoeren
      if (vm.selArticleId) {
        query();
      }
    }

    function openDatepicker(id) {
      switch (id) {
        case "tht-datum":
          vm.selExpiryDateStatus.opened = true;
          break;
        case "datum_vanaf":
          vm.selDateFromStatus.opened = true;
          break;
        case "datum_tm":
          vm.selDateToStatus.opened = true;
          break;
        default:
          $log.error(`Unknown datepicker '${id}'`);
      }
    }

    function closeAlert() {
      vm.alert = null;
    }

    function query(qparams) {
      // Queryparameters bepalen
      let params = {};
      if (qparams) {
        params = qparams;
      } else {
        if (vm.selCustomerId) {
          params.klantnr = vm.selCustomerId;
        }
        if (vm.selArticleId) {
          params.artikelnr = vm.selArticleId;
        }
        if (vm.selExpiryDate) {
          let year = vm.selExpiryDate.getFullYear();
          let month = vm.selExpiryDate.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          let day = vm.selExpiryDate.getDate();
          if (day < 10) {
            day = "0" + day;
          }
          params.tht_datum = year + "-" + month + "-" + day;
        }
        if (vm.selDateFrom) {
          let year = vm.selDateFrom.getFullYear();
          let month = vm.selDateFrom.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          let day = vm.selDateFrom.getDate();
          if (day < 10) {
            day = "0" + day;
          }
          params.datum_vanaf = year + "-" + month + "-" + day;
        }
        if (vm.selDateTo) {
          let year = vm.selDateTo.getFullYear();
          let month = vm.selDateTo.getMonth() + 1;
          if (month < 10) {
            month = "0" + month;
          }
          let day = vm.selDateTo.getDate();
          if (day < 10) {
            day = "0" + day;
          }
          params.datum_tm = year + "-" + month + "-" + day;
        }
        if (vm.selSSCC) {
          params.ssccnr = vm.selSSCC;
        }
        if (vm.selLotcode) {
          params.lotcode = vm.selLotcode;
        }
        if (vm.selSupplierPalId) {
          params.palletnr_lev = vm.selSupplierPalId;
        }
        vm.currentPage = parseInt(vm.currentPage);
        if (vm.currentPage > 1) {
          params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
        }
        params.limit = vm.maxItemsPerPage;
        if (vm.sort) {
          params.sort = vm.sort;
        }
      }
      vm.currentParams = params;

      // Request uitvoeren
      vm.loading = true;
      RecallService
        .findAll(params)
        .then((res) => {
          vm.articles = res.data;
          let contentRange = res.headers()["content-range"];
          vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
          vm.totalResults = parseInt(vm.totalResults);
          vm.loading = false;
        })
        .catch((err) => {
          vm.alert = { type: "danger", msg: err.errorText };
          vm.loading = false;
        });
    }

    function validateForm(form) {
      // Custom validatie van formulier voor datum-range
      if (form) {
        // Eerst alles op gevalideerd zetten, daarna controleren
        form.$setValidity('dateToEmpty', true, 'datum_tm');
        form.$setValidity('dateFromEmpty', true, 'datum_vanaf');
        form.$setValidity('dateRangeOk', true, 'datum_tm');

        // Als datum vanaf gevuld, dan ook datum t/m vullen!
        if (vm.selDateFrom && !vm.selDateTo) {
          $log.debug('datum van gevuld, datum t/m leeg!');
          form.$setValidity('dateToEmpty', false, 'datum_tm');
        }

        // Als datum tm gevuld, dan ook datum vanaf vullen!
        if (vm.selDateTo && !vm.selDateFrom) {
          $log.debug('datum van gevuld, datum t/m leeg!');
          form.$setValidity('dateFromEmpty', false, 'datum_vanaf');
        }

        // Datum tm mag niet voor datum vanaf liggen!
        if (vm.selDateFrom && vm.selDateTo && vm.selDateTo < vm.selDateFrom) {
          $log.debug('datum t/m ligt voor datum van!')
          form.$setValidity('dateRangeOk', false, 'datum_tm');
        }
      }
    }

    function search(form) {

      validateForm(form);

      if (!form.$valid) { $log.debug("form not valid", form.$error); return; }

      // Reset paginatie
      vm.currentPage = 1;
      $scope.currentPage = 1;

      // Query parameters vullen
      $location.search("klantnr", vm.selCustomerId ? vm.selCustomerId : null);
      $location.search("artikelnr", vm.selArticleId ? vm.selArticleId : null);
      if (vm.selExpiryDate) {
        let year = vm.selExpiryDate.getFullYear();
        let month = vm.selExpiryDate.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = vm.selExpiryDate.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        $location.search("tht_datum", year + "-" + month + "-" + day);
      } else {
        $location.search("tht_datum", null);
      }
      if (vm.selDateFrom) {
        let year = vm.selDateFrom.getFullYear();
        let month = vm.selDateFrom.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = vm.selDateFrom.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        $location.search("datum_vanaf", year + "-" + month + "-" + day);
      } else {
        $location.search("datum_vanaf", null);
      }
      if (vm.selDateTo) {
        let year = vm.selDateTo.getFullYear();
        let month = vm.selDateTo.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = vm.selDateTo.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        $location.search("datum_tm", year + "-" + month + "-" + day);
      } else {
        $location.search("datum_tm", null);
      }
      $location.search("ssccnr", vm.selSSCC || null);
      $location.search("lotcode", vm.selLotcode || null);
      $location.search("palletnr_lev", vm.selSupplierPalId || null);

      // Query uitvoeren met nieuwe parameters
      query();
    }

    function changePage() {
      // De pagination control bewaart de huidige pagina in $scope
      vm.currentPage = $scope.currentPage;
      $location.search("p", vm.currentPage);
      vm.currentParams['offset'] = (vm.currentPage - 1) * vm.maxItemsPerPage;
      query(vm.currentParams);
    }

    function changeItemsPerPage(limit) {
      vm.maxItemsPerPage = limit;
      $location.search("limit", vm.maxItemsPerPage);
      vm.currentParams['limit'] = vm.maxItemsPerPage;
      vm.changePage(vm.currentParams);
    }

    function orderBy(column) {
      // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
      if (column === vm.sort) {
        vm.sort = "-" + column;
      } else {
        vm.sort = column;
      }
      vm.currentPage = 1;
      $scope.currentPage = 1;
      $location.search("p", vm.currentPage);
      $location.search("limit", vm.maxItemsPerPage);
      $location.search("sort", vm.sort);
      vm.currentParams['offset'] = 0;
      vm.currentParams['limit'] = 1;
      vm.currentParams['sort'] = vm.sort;
      query(vm.currentParams);
    }

    function refresh() {
      query(vm.currentParams);
    }

    // Downloaden van de csv.
    function download() {
      let params = JSON.parse(JSON.stringify(vm.currentParams));
      params['format'] = "csv";
      delete params.offset;
      delete params.limit;
      /**
       * Parameters zijn bekend in vm.currentParams
      let params = {
        format: "csv"
      };
      if (vm.selCustomerId) {
        params.klantnr = vm.selCustomerId;
      }
      if (vm.selArticleId) {
        params.artikelnr = vm.selArticleId;
      }
      if (vm.selExpiryDate) {
        let year = vm.selExpiryDate.getFullYear();
        let month = vm.selExpiryDate.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = vm.selExpiryDate.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        params.tht_datum = year + "-" + month + "-" + day;
      }
      if (vm.selDateFrom) {
        let year = vm.selDateFrom.getFullYear();
        let month = vm.selDateFrom.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = vm.selDateFrom.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        params.datum_vanaf = year + "-" + month + "-" + day;
      }
      if (vm.selDateTo) {
        let year = vm.selDateTo.getFullYear();
        let month = vm.selDateTo.getMonth() + 1;
        if (month < 10) {
          month = "0" + month;
        }
        let day = vm.selDateTo.getDate();
        if (day < 10) {
          day = "0" + day;
        }
        params.datum_tm = year + "-" + month + "-" + day;
      }
      if (vm.selSSCC) {
        params.ssccnr = vm.selSSCC;
      }
      if (vm.selLotcode) {
        params.lotcode = vm.selLotcode;
      }
      if (vm.selSupplierPalId) {
        params.palletnr_lev = vm.selSupplierPalId;
      }
      */
      RecallService.findAll(params, "blob")
        .then((res) => {
          let fileData = res.data;
          let filename = "recall.csv"

          if (navigator.appVersion.toString().indexOf(".NET") > 0) {
            window.navigator.msSaveBlob(fileData, filename);
          } else {
            let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
            link.href = URL.createObjectURL(fileData);
            link.download = filename;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            link.onclick = function () {
              window.URL.revokeObjectURL(link.href);
            };
          }
        })
        .catch((err) => {
          vm.alert = { type: "danger", msg: err.errorText };
          vm.loading = false;
        });
    }

    activate();
  }
})();;
(function () {
  "use strict";

  angular
    .module("App")
    .factory("RecallService", RecallService);

  RecallService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
  function RecallService($log, $http, $q, ConfigService, SessionService) {
    let service = {
      findAll: findAll
    };

    initialize();

    return service;

    function initialize() {
      $log.debug("Initialize RecallService");
    }

    function findAll(params, responseType) {
      let username = SessionService.getUsername();
      let url = ConfigService.get("apiUrl") + `/users/${username}/recall`;
      // Cache = true voorkomt dubbele aanroep $http.get!
      let config = {
        params: params,
        cache: true
      };
      if (responseType) {
        config.responseType = responseType;
      }
      return $http
        .get(url, config)
        .then((res) => {
          $log.debug("Recall found");
          return res;
        })
        .catch((err) => {
          let data = {
            errorText: "",
            status: err.status
          }
          if (err.status >= 500) {
            $log.error(err);
            data.errorText = "Internal server error";
          } else {
            $log.warn(err);
            data.errorText = "No data found";
          }
          if (typeof err.data === "object" && err.data) {
            if (err.data.errorText) {
              data.errorText = err.data.errorText;
            }
          }
          return $q.reject(data);
        });
    }
  }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("ReceiptDetailCtrl", ReceiptDetailCtrl);
    
    ReceiptDetailCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "ReceiptService", "ReceiptDetailService"];
    function ReceiptDetailCtrl($log, $scope, $location, $routeParams, ReceiptService, ReceiptDetailService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;

        vm.customerId = Number($routeParams.klantnr);
        vm.receiptId = Number($routeParams.ontvangstnr);
        vm.receipt = null;
        vm.receiptDetails = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "artikelnr";
        vm.orderBy = orderBy;

        // Zoeken
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;
        vm.statusOptions = [
            {
                id: "I",
                description: "Initieel"
            }, {
                id: "A",
                description: "Actief"
            }, {
                id: "O",
                description: "Ontvangstbon geprint"
            }, {
                id: "D",
                description: "Bevestigd in magazijn"
            }, {
                id: "B",
                description: "Bevestigd op kantoor"
            } ,{
                id: "Z",
                description: "Geannuleerd"
            }
        ];

        function activate() {
            $log.debug("Activate ReceiptDetailCtrl");
            queryReceipt()
                .then(() => {
                    queryDetails();
                });
        }

        function closeAlert() {
            vm.alert = null;
        }

        function queryReceipt() {
            vm.loading = true;
            return ReceiptService 
                .find(vm.customerId, vm.receiptId)
                .then((res) => {
                    vm.receipt = res.data;
                    if (vm.receipt.klantnr && vm.receipt.klantnaam) {
                        vm.receipt.klant = vm.receipt.klantnr + " - " + vm.receipt.klantnaam;
                    } else {
                        vm.receipt.klant = "" + vm.receipt.klantnr + vm.receipt.klantnaam;
                    }
                    if (vm.receipt.leveranciernr && vm.receipt.leveranciernaam) {
                        vm.receipt.leverancier = vm.receipt.leveranciernr + " - " + vm.receipt.leveranciernaam;
                    } else {
                        vm.receipt.leverancier = "" + vm.receipt.leveranciernr + vm.receipt.leveranciernaam;
                    }
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                })
        }

        function queryDetails() {
            let params = {};
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            return ReceiptDetailService
                .findAll(vm.customerId, vm.receiptId, params)
                .then((res) => {
                    vm.receiptDetails = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            queryDetails();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            queryDetails();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            queryDetails();
        }

        function refresh() {
            queryReceipt()
                .then(() => {
                    queryDetails();
                });
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            ReceiptDetailService.findAll(vm.customerId, vm.receiptId, params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "ontvangstdetails.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("ReceiptDetailService", ReceiptDetailService);
    
    ReceiptDetailService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function ReceiptDetailService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize ReceiptDetailService");
        }

        function findAll(customerId, receiptId, params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/klanten/${customerId}/ontvangsten/${receiptId}/details`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Receipt details found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("ReceiptCtrl", ReceiptCtrl);
    
    ReceiptCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "ReceiptService", "CustomerService"];
    function ReceiptCtrl($log, $scope, $location, $routeParams, ReceiptService, CustomerService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;
        vm.openDatepicker = openDatepicker;
        vm.clickItem = clickItem;

        vm.customers = CustomerService.getCustomers();
        vm.receipts = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "klantnr";
        vm.orderBy = orderBy;

        // Zoeken
        vm.selCustomerId = Number($routeParams.klantnr) || (vm.customers.length > 0 ? vm.customers[0].klantnr : null);
        vm.selReceiptId = $routeParams.ontvangstnr || null;
        vm.selStatusFrom = $routeParams.status_van || "I";
        vm.selStatusTo = $routeParams.status_tm || "Z";
        vm.selSupplierId = $routeParams.leveranciernr || null;
        vm.selDeliveryDateFrom = $routeParams.afleverdatum_van ? new Date($routeParams.afleverdatum_van) : new Date();
        vm.selDeliveryDateTo = $routeParams.afleverdatum_tm ? new Date($routeParams.afleverdatum_tm) : new Date();
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;
        vm.statusOptions = [
            {
                id: "I",
                description: "Initieel"
            }, {
                id: "A",
                description: "Actief"
            }, {
                id: "O",
                description: "Ontvangstbon geprint"
            }, {
                id: "D",
                description: "Bevestigd in magazijn"
            }, {
                id: "B",
                description: "Bevestigd op kantoor"
            } ,{
                id: "Z",
                description: "Geannuleerd"
            }
        ];

        // Datepicker
        vm.selDateOptions = {
            startingDay: 1
        };
        vm.selDateFormat = "dd-MM-yyyy";
        vm.altInputFormats = ["d!-M!-yyyy"];
        vm.selDeliveryDateFromStatus = { opened: false };
        vm.selDeliveryDateToStatus = { opened: false };

        function activate() {
            $log.debug("Activate ReceiptCtrl");
            query();
        }

        function openDatepicker(id) {
            switch (id) {
                case "afleverdatum-van":
                    vm.selDeliveryDateFromStatus.opened = true;
                    break;
                case "afleverdatum-tm":
                    vm.selDeliveryDateToStatus.opened = true;
                    break;
                default:
                    $log.error(`Unknown datepicker '${id}'`);
            }
        }

        function clickItem(index) {
            let customerId = vm.receipts[index].klantnr;
            let receiptId = vm.receipts[index].ontvangstnr;
            $location
                .path(`/customers/${customerId}/receipts/${receiptId}`)
                .search({});
        }

        function closeAlert() {
            vm.alert = null;
        }

        function query() {
            let params = {};
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selReceiptId) {
                params.ontvangstnr = vm.selReceiptId;
            }
            if (vm.selStatusFrom) {
                params.status_van = vm.selStatusFrom;
            }
            if (vm.selStatusTo) {
                params.status_tm = vm.selStatusTo;
            }
            if (vm.selSupplierId) {
                params.leveranciernr = vm.selSupplierId;
            }
            if (vm.selDeliveryDateFrom) {
                let year = vm.selDeliveryDateFrom.getFullYear();
                let month = vm.selDeliveryDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.afleverdatum_van = year + "-" + month + "-" + day;
            }
            if (vm.selDeliveryDateTo) {
                let year = vm.selDeliveryDateTo.getFullYear();
                let month = vm.selDeliveryDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.afleverdatum_tm = year + "-" + month + "-" + day;
            }
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            ReceiptService
                .findAll(params)
                .then((res) => {
                    vm.receipts = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("klantnr", vm.selCustomerId || null);
            $location.search("ontvangstnr", vm.selReceiptId || null);
            $location.search("status_van", vm.selStatusFrom || null);
            $location.search("status_tm", vm.selStatusTo || null);
            $location.search("leveranciernr", vm.selSupplierId || null);
            if (vm.selDeliveryDateFrom) {
                let year = vm.selDeliveryDateFrom.getFullYear();
                let month = vm.selDeliveryDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                $location.search("afleverdatum_van", year + "-" + month + "-" + day);
            } else {
                $location.search("afleverdatum_van", null);
            }
            if (vm.selDeliveryDateTo) {
                let year = vm.selDeliveryDateTo.getFullYear();
                let month = vm.selDeliveryDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                $location.search("afleverdatum_tm", year + "-" + month + "-" + day);
            } else {
                $location.search("afleverdatum_tm", null);
            }
            query();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            query();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            query();
        }

        function refresh() {
            query();
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selReceiptId) {
                params.ontvangstnr = vm.selReceiptId;
            }
            if (vm.selStatusFrom) {
                params.status_van = vm.selStatusFrom;
            }
            if (vm.selStatusTo) {
                params.status_tm = vm.selStatusTo;
            }
            if (vm.selSupplierId) {
                params.leveranciernr = vm.selSupplierId;
            }
            if (vm.selDeliveryDateFrom) {
                let year = vm.selDeliveryDateFrom.getFullYear();
                let month = vm.selDeliveryDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.afleverdatum_van = year + "-" + month + "-" + day;
            }
            if (vm.selDeliveryDateTo) {
                let year = vm.selDeliveryDateTo.getFullYear();
                let month = vm.selDeliveryDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDeliveryDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.afleverdatum_tm = year + "-" + month + "-" + day;
            }
            ReceiptService.findAll(params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "ontvangsten.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("ReceiptService", ReceiptService);
    
    ReceiptService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function ReceiptService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            find: find,
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize ReceiptService");
        }

        function find(customerId, receiptId) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/klanten/${customerId}/ontvangsten/${receiptId}`;
            return $http 
                .get(url)
                .then((res) => {
                    $log.debug("Receipt found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }

        function findAll(params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/ontvangsten`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Receipts found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("SessionService", SessionService);
    
    SessionService.$inject = ["$log"];
    function SessionService($log) {
        let service = {
            create: create,
            destroy: destroy,
            getToken: getToken,
            getUsername: getUsername,
            getFullName: getFullName,
            setFullName: setFullName,
            getLanguage: getLanguage,
            setLanguage: setLanguage
        };

        let token = null;
        let username = null;
        let fullName = null;
        let languageCode = null;

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize SessionService");
            token = sessionStorage.getItem("token");
            username = sessionStorage.getItem("username");
            fullName = sessionStorage.getItem("fullName");
            languageCode = sessionStorage.getItem("languageCode");
        }

        function create(session) {
            token = session.token;
            username = session.username;
            $log.debug(`Session created for ${username} with token ${token}`);
            try {
                sessionStorage.setItem("token", token);
                sessionStorage.setItem("username", username);
            } catch (err) {
                $log.error(err);
            }
        }

        function destroy() {
            token = null;
            username = null;
            fullName = null;
            $log.debug("Session destroyed");
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("username");
            sessionStorage.removeItem("fullName");
            sessionStorage.removeItem("languageCode");
        }

        function getToken() {
            return token;
        }

        function getUsername() {
            return username;
        }

        function getFullName() {
            return fullName;
        }

        function setFullName(name) {
            fullName = name;
            try {
                sessionStorage.setItem("fullName", fullName);
            } catch (err) {
                $log.error(err);
            }
        }

        function getLanguage() {
            return languageCode;
        }

        function setLanguage(lang) {
            languageCode = lang;
            try {
                sessionStorage.setItem("languageCode", lang);
            } catch (err) {
                $log.error(err);
            }
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("SettingsService", SettingsService);
    
    SettingsService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function SettingsService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            find: find
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize SettingsService");
        }

        function find() {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/instellingen`;
            return $http
                .get(url)
                .then((res) => {
                    $log.debug("Settings found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "Invalid username";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("StockDetailCtrl", StockDetailCtrl);
    
    StockDetailCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "StockService", "StockDetailService"];
    function StockDetailCtrl($log, $scope, $location, $routeParams, StockService, StockDetailService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;

        vm.customerId = Number($routeParams.klantnr);
        vm.articleId = $routeParams.artikelnr;
        vm.batchId = $routeParams.partijnr;
        vm.article = null;
        vm.stockDetails = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "voorraad_id";
        vm.orderBy = orderBy;

        // Zoeken
        vm.refresh = refresh;
        vm.download = download;

        function activate() {
            $log.debug("Activate StockDetailCtrl");
            queryStock()
                .then(() => {
                    queryDetails();
                });
        }

        function closeAlert() {
            vm.alert = null;
        }

        function queryStock() {
            vm.loading = true;
            return StockService 
                .find(vm.customerId, vm.articleId, vm.batchId)
                .then((res) => {
                    vm.article = res.data;
                    if (vm.article.klantnr && vm.article.klantnaam) {
                        vm.article.klant = vm.article.klantnr + " - " + vm.article.klantnaam;
                    } else {
                        vm.article.klant = "" + vm.article.klantnr + vm.article.klantnaam;
                    }
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                })
        }

        function queryDetails() {
            let params = {};
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            return StockDetailService
                .findAll(vm.customerId, vm.articleId, vm.batchId, params)
                .then((res) => {
                    vm.stockDetails = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            queryDetails();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            queryDetails();
        }

        function refresh() {
            queryStock()
                .then(() => {
                    queryDetails();
                });
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            StockDetailService.findAll(vm.customerId, vm.articleId, vm.batchId, params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "stockdetails.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("StockDetailService", StockDetailService);
    
    StockDetailService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function StockDetailService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize StockDetailService");
        }

        function findAll(customerId, articleId, batchId, params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/klanten/${customerId}/artikelen/${articleId}/partijen/${batchId}/voorraad`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Stock details found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("StockTrailCtrl", StockTrailCtrl);
    
    StockTrailCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "$uibModal", "StockTrailService", "CustomerService"];
    function StockTrailCtrl($log, $scope, $location, $routeParams, $uibModal, StockTrailService, CustomerService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;
        vm.openDatepicker = openDatepicker;

        vm.customers = CustomerService.getCustomers();
        vm.data = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "datum";
        vm.orderBy = orderBy;

        // Zoeken
        vm.selDateFrom = $routeParams.datum_van ? new Date($routeParams.datum_van) : new Date();
        vm.selDateTo = $routeParams.datum_tm ? new Date($routeParams.datum_tm) : new Date();
        vm.selCustomerId = Number($routeParams.klantnr) || (vm.customers.length > 0 ? vm.customers[0].klantnr : null);
        vm.selArticleId = $routeParams.artikelnr || null;
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;

        // Datepicker
        vm.selDateOptions = {
            startingDay: 1
        };
        vm.selDateFormat = "dd-MM-yyyy";
        vm.altInputFormats = ["d!-M!-yyyy"];
        vm.selDateFromStatus = { opened: false };
        vm.selDateToStatus = { opened: false };


        function activate() {
            $log.debug("Activate StockTrailCtrl");
            query();
        }

        function openDatepicker(id) {
            switch (id) {
                case "datum-van":
                    vm.selDateFromStatus.opened = true;
                    break;
                case "datum-tm":
                    vm.selDateToStatus.opened = true;
                    break;
                default:
                    $log.error(`Unknown datepicker '${id}'`);
            }
        }

        function closeAlert() {
            vm.alert = null;
        }

        function query() {
            let params = {};
            if (vm.selDateFrom) {
                let year = vm.selDateFrom.getFullYear();
                let month = vm.selDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.datum_van = year + "-" + month + "-" + day;
            }
            if (vm.selDateTo) {
                let year = vm.selDateTo.getFullYear();
                let month = vm.selDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.datum_tm = year + "-" + month + "-" + day;
            }
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            StockTrailService
                .findAll(params)
                .then((res) => {
                    vm.data = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("klantnr", vm.selCustomerId ? vm.selCustomerId : null);
            $location.search("artikelnr", vm.selArticleId ? vm.selArticleId : null);
            if (vm.selDateFrom) {
                let year = vm.selDateFrom.getFullYear();
                let month = vm.selDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                $location.search("datum_van", year + "-" + month + "-" + day);
            } else {
                $location.search("datum_van", null);
            }
            if (vm.selDateTo) {
                let year = vm.selDateTo.getFullYear();
                let month = vm.selDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                $location.search("datum_tm", year + "-" + month + "-" + day);
            } else {
                $location.search("datum_tm", null);
            }
            query();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            query();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            query();
        }

        function refresh() {
            query();
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            if (vm.selDateFrom) {
                let year = vm.selDateFrom.getFullYear();
                let month = vm.selDateFrom.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDateFrom.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.datum_van = year + "-" + month + "-" + day;
            }
            if (vm.selDateTo) {
                let year = vm.selDateTo.getFullYear();
                let month = vm.selDateTo.getMonth() + 1;
                if (month < 10) {
                    month = "0" + month;
                }
                let day = vm.selDateTo.getDate();
                if (day < 10) {
                    day = "0" + day;
                }
                params.datum_tm = year + "-" + month + "-" + day;
            }
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            StockTrailService.findAll(params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "voorraadtrail.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("StockTrailService", StockTrailService);
    
    StockTrailService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function StockTrailService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize StockTrailService");
        }

        function findAll(params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/voorraadtrail`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Stock trail found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .controller("StockCtrl", StockCtrl);
    
    StockCtrl.$inject = ["$log", "$scope", "$location", "$routeParams", "StockService", "CustomerService"];
    function StockCtrl($log, $scope, $location, $routeParams, StockService, CustomerService) {
        let vm = this;
        
        vm.alert = null;
        vm.closeAlert = closeAlert;
        vm.loading = false;
        vm.clickItem = clickItem;

        vm.customers = CustomerService.getCustomers();
        vm.stock = null;
        vm.contentRange = {};
        vm.currentPage = Number($routeParams.p) || 1;
        $scope.currentPage = vm.currentPage;
        vm.totalResults = 0;
        vm.changePage = changePage;
        vm.maxItemsPerPage = Number($routeParams.limit) || 20;
        vm.changeItemsPerPage = changeItemsPerPage;
        vm.sort = $routeParams.sort || "klantnr";
        vm.orderBy = orderBy;

        // Zoeken
        vm.selCustomerId = Number($routeParams.klantnr) || (vm.customers.length > 0 ? vm.customers[0].klantnr : null);
        vm.selArticleId = $routeParams.artikelnr || null;
        vm.selShowActiveStockOnly = $routeParams.alleen_met_voorraad_jn == "N" ? false : true;
        vm.search = search;
        vm.refresh = refresh;
        vm.download = download;

        function activate() {
            $log.debug("Activate StockCtrl");
            query();
        }

        function clickItem(index) {
            let customerId = vm.stock[index].klantnr;
            let articleId = vm.stock[index].artikelnr;
            let batchId = vm.stock[index].partijnr;
            $location
                .path(`/customers/${customerId}/articles/${articleId}/batches/${batchId}/stock`)
                .search({});
        }

        function closeAlert() {
            vm.alert = null;
        }

        function query() {
            let params = {};
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            if (vm.selShowActiveStockOnly) {
                params.alleen_met_voorraad_jn = "J";
            }
            vm.currentPage = parseInt(vm.currentPage);
            if (vm.currentPage > 1) {
                params.offset = (vm.currentPage - 1) * vm.maxItemsPerPage;
            }
            params.limit = vm.maxItemsPerPage;
            if (vm.sort) {
                params.sort = vm.sort;
            }
            vm.loading = true;
            StockService
                .findAll(params)
                .then((res) => {
                    vm.stock = res.data;
                    let contentRange = res.headers()["content-range"];
                    vm.totalResults = contentRange.substring(contentRange.indexOf("/") + 1);
                    vm.loading = false;
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        function search() {
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("klantnr", vm.selCustomerId ? vm.selCustomerId : null);
            $location.search("artikelnr", vm.selArticleId ? vm.selArticleId : null);
            if (vm.selShowActiveStockOnly) {
                $location.search("alleen_met_voorraad_jn", "J");
            } else {
                $location.search("alleen_met_voorraad_jn", "N");
            }
            query();
        }

        function changePage() {
            // De pagination control bewaart de huidige pagina in $scope
            vm.currentPage = $scope.currentPage;
            $location.search("p", vm.currentPage);
            query();
        }

        function changeItemsPerPage(limit) {
            vm.maxItemsPerPage = limit;
            $location.search("limit", vm.maxItemsPerPage);
            vm.changePage();
        }

        function orderBy(column) {
            // Indien er voor de tweede keer op de kolom gesorteerd wordt, de volgorde omdraaien.
            if (column === vm.sort) {
                vm.sort = "-" + column;
            } else {
                vm.sort = column;
            }
            vm.currentPage = 1;
            $scope.currentPage = 1;
            $location.search("p", vm.currentPage);
            $location.search("limit", vm.maxItemsPerPage);
            $location.search("sort", vm.sort);
            query();
        }

        function refresh() {
            query();
        }

        // Downloaden van de csv.
        function download() {
            let params = {
                format: "csv"
            };
            if (vm.selCustomerId) {
                params.klantnr = vm.selCustomerId;
            }
            if (vm.selArticleId) {
                params.artikelnr = vm.selArticleId;
            }
            if (vm.selShowActiveStockOnly) {
                params.alleen_met_voorraad_jn = "J";
            }
            StockService.findAll(params, "blob") 
                .then((res) => {
                    let fileData = res.data;
                    let filename = "voorraad.csv"

                    if (navigator.appVersion.toString().indexOf(".NET") > 0) {
                        window.navigator.msSaveBlob(fileData, filename);
                    } else {
                        let link = document.createElementNS("http://www.w3.org/1999/xhtml", "a");
                        link.href = URL.createObjectURL(fileData);
                        link.download = filename;

                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        link.onclick = function() {
                            window.URL.revokeObjectURL(link.href);
                        };
                    }
                })
                .catch((err) => {
                    vm.alert = { type: "danger", msg: err.errorText };
                    vm.loading = false;
                });
        }

        activate();
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .factory("StockService", StockService);
    
    StockService.$inject = ["$log", "$http", "$q", "ConfigService", "SessionService"];
    function StockService($log, $http, $q, ConfigService, SessionService) {
        let service = {
            find: find,
            findAll: findAll
        };

        initialize();

        return service;

        function initialize() {
            $log.debug("Initialize StockService");
        }

        function find(customerId, articleId, batchId) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/klanten/${customerId}/artikelen/${articleId}/partijen/${batchId}`;
            return $http
                .get(url)
                .then((res) => {
                    $log.debug("Stock detail found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }

        function findAll(params, responseType) {
            let username = SessionService.getUsername();
            let url = ConfigService.get("apiUrl") + `/users/${username}/voorraad`;
            let config = {
                params: params
            };
            if (responseType) {
                config.responseType = responseType;
            }
            return $http
                .get(url, config)
                .then((res) => {
                    $log.debug("Stock found");
                    return res;
                })
                .catch((err) => {
                    let data = {
                        errorText: "",
                        status: err.status
                    }
                    if (err.status >= 500) {
                        $log.error(err);
                        data.errorText = "Internal server error";
                    } else {
                        $log.warn(err);
                        data.errorText = "No data found";
                    }
                    if (typeof err.data === "object" && err.data) {
                        if (err.data.errorText) {
                            data.errorText = err.data.errorText;
                        }
                    }
                    return $q.reject(data);
                });
        }
    }
})();;
(function () {
    "use strict";

    angular
        .module("App")
        .config(translateNL);
    
    translateNL.$inject = ["$translateProvider"];
    function translateNL($translateProvider) {
        $translateProvider.translations('DE', {
            "Actief": "Aktiv",
            "Acties": "Aktionen",
            "Afleveradres": "Lieferadresse",
            "Afleverdatum": "Lieferdatum",
            "Afleverdatum t/m": "Lieferdatum zu",
            "Afleverdatum van": "Lieferdatum von",
            "Aflevernaam" : "Liefername",
            "Afleverplaats": "Lieferort",
            "Alleen met voorraad": "Nur mit Vorrat",
            "Annuleren": "Stornieren",
            "Artikel": "Artikel",
            "Artikelen": "Artikel",
            "Artikelomschrijving": "Artikelbeschreibung",
            "Artikel verplicht": "Artikel erforderlich",
            "Besteld": "Bestellt",
            "Bevestigd": "Bestätigt",
            "Bevestigd in magazijn": "Bestätigt im Lagerhaus",
            "Bevestigd op kantoor": "Bestätigt im Büro",
            "Blokkeren": "Blockieren",
            "Breedte": "Breite",
            "Bundels": "Bündel",
            "Castelein WMS": "Castelein WMS",
            "Collipicken": "Picking",
            "Datum": "Datum",
            "Datum t/m": "Datum zu",
            "Datum t/m niet gevuld": "Datum zu ist leer",
            "Datum t/m niet juist": "Datum zu ist ungültig",
            "Datum van": "Datum von",
            "Datum van niet gevuld": "Datum von ist leer",
            "Deblokkeren": "Deblockieren",
            "Deels vrijgegeven": "Teilweise freigegeben",
            "Details": "Details",
            "Documentnr": "Dokumentnummer",
            "Doorgaan": "Weiter",
            "Download": "Download",
            "DPU": "DPU",
            "DPU overzicht": "DPU Übersicht",
            "Eancode": "EAN-Code",
            "Emballage": "Verpackung",
            "Er zijn geen gegevens gevonden die voldoen aan uw selectie.": "Kein Daten gefünden für Ihren Auswahl",
            "Externe partijcode": "Externer Partei-Code",
            "Filter": "Filter",
            "Geannuleerd": "Storniert",
            "Geblokkeerd": "Blockiert",
            "Gebruikersnaam": "Benutzername",
            "Geleverd": "Geliefert",
            "Geselecteerd": "Ausgewählt",
            "Gewicht": "Gewicht",
            "Herhaal wachtwoord": "Passwort wiederholen",
            "Herhaal wachtwoord!": "Passwort wiederholen!",
            "Het nieuwe wachtwoord is naar uw e-mailadres gestuurd.": "Das neue Passwort wurde an Ihre E-Mail-Adresse gesendet",
            "Hoogte": "Höhe",
            "Initieel": "Anfang",
            "Inloggen": "Anmelden",
            "Inslag datum": "Einnahme Datum",
            "Invoer verplicht!": "Eingabe erforderlich!",
            "Klant": "Kunde",
            "Lagenpick": "Schichten Picking",
            "Lengte": "Länge",
            "Leverancier": "Lieferant",
            "Losse stuks": "Stücke",
            "Lotcode": "Lotcode",
            "Melding": "Text",
            "Mutatie": "Mutation",
            "Naam": "Name",
            "Nieuw wachtwoord": "Neues Passwort",
            "OK": "OK",
            "Omschrijving": "Beschreibung",
            "Ontvangst": "Einnahme",
            "Ontvangsten": "Einnahmen",
            "Ontvangstbon geprint": "Einnahmedokument gedruckt",
            "Order": "Bestellung",
            "Ordernr afleveradres": "Bestellnummer Lieferadresse",
            "Ordernr klant": "Bestellnummer Kunde",
            "Orderreferentie": "Bestellreferenz",
            "Orders": "Bestellungen",
            "Oud wachtwoord": "Altes Passwort",
            "Overzichten": "Übersichten",
            "Pakbonnr leverancier": "Lieferscheinnummer Lieferant",
            "Palletnr leverancier": "Palettennummer Lieferant",
            "Partij": "Partei",
            "Recall lijst": "Rückrufliste",
            "Resultaat": "Ergebnis",
            "Sluiten": "schließen",
            "SSCC": "SSCC",
            "SSCC inslag": "SSCC Einnahme",
            "Status": "Status",
            "Status t/m": "Status zu",
            "Status van": "Status bis",
            "Stuks": "Stücke",
            "Stuks per pallet": "Stücke pro Palette",
            "THT datum": "MDH Datum",
            "Totaal": "Insgesamt",
            "Type": "Typ",
            "Uitloggen": "Abmelden",
            "Vandaag": "Heute",
            "Verversen": "Aktualisieren",
            "Volgnr": "Sequenznummer",
            "Volle pallet": "Volle Palette",
            "Voorraad": "Vorrat",
            "Voorraad (de)blokkeren": "Vorrat (de)blockieren",
            "Voorraad ID": "Vorrat-ID",
            "Voorraad historie": "Vorrat geschichte",
            "Voorraadmutaties": "Mutationen der Vorräte",
            "Vrachtbrief afgemeld": "Lieferschein abgemeldet",
            "Vrachtbrief geprint": "Lieferschein gedruckt",
            "Vrijgegeven voor picking": "Freigegeben für picking",
            "Wachtwoord": "Passwort",
            "Wachtwoord herstellen": "Passwort erholen",
            "Wachtwoord vergeten?": "Passwort vergessen?",
            "Wachtwoord wijzigen": "Passwort ändern",
            "Warehouse limit dagen": "Lager Limit Tage",
            "Welkom {naam}": "Wilkommen {{username}}", // LET OP: {{username}} wordt vervangen door de volledige naam van de gebruiker.
            "Wissen": "Löschen",
            "Zoeken": "Suchen"
        }); 
    }
})();
(function () {
    "use strict";

    angular
        .module("App")
        .config(translateNL);
    
    translateNL.$inject = ["$translateProvider"];
    function translateNL($translateProvider) {
        $translateProvider.translations('EN', {
            "Actief": "Active",
            "Acties": "Actions",
            "Afleveradres": "Delivery address",
            "Afleverdatum": "Delivery date",
            "Afleverdatum t/m": "Delivery date to",
            "Afleverdatum van": "Delivery date from",
            "Aflevernaam" : "Delivery name",
            "Afleverplaats": "Delivery place",
            "Alleen met voorraad": "Stock only",
            "Annuleren": "Cancel",
            "Artikel": "Item",
            "Artikelen": "Items",
            "Artikelomschrijving": "Item description",
            "Artikel verplicht": "Item required",
            "Besteld": "Ordered",
            "Bevestigd": "Confirmed",
            "Bevestigd in magazijn": "Confirmed at warehouse",
            "Bevestigd op kantoor": "Confirmed at office",
            "Blokkeren": "Block",
            "Breedte": "Width",
            "Bundels": "Bundles",
            "Castelein WMS": "Castelein WMS",
            "Collipicken": "Colli picking",
            "Datum": "Date",
            "Datum t/m": "Date to",
            "Datum t/m niet gevuld": "Date to is empty",
            "Datum t/m niet juist": "Date to is not valid",
            "Datum van": "Date from",
            "Datum van niet gevuld": "Date from is empty",
            "Deblokkeren": "Unblock",
            "Deels vrijgegeven": "Partially released",
            "Details": "Details",
            "Documentnr": "Doc nr",
            "Doorgaan": "Proceed",
            "Download": "Download",
            "DPU": "DPU",
            "DPU overzicht": "DPU overview",
            "Eancode": "EAN code",
            "Emballage": "PACKING",
            "Er zijn geen gegevens gevonden die voldoen aan uw selectie.": "No items found matching selection!",
            "Externe partijcode": "External BATCH code",
            "Filter": "Filter",
            "Geannuleerd": "Canceled",
            "Geblokkeerd": "Blocked",
            "Gebruikersnaam": "User name",
            "Geleverd": "Delivered",
            "Geselecteerd": "Selected",
            "Gewicht": "Weight",
            "Herhaal wachtwoord": "Repeat password",
            "Herhaal wachtwoord!": "Repeat password",
            "Het nieuwe wachtwoord is naar uw e-mailadres gestuurd.": "The new password has been sent to your email address",
            "Hoogte": "Height",
            "Initieel": "Initial",
            "Inloggen": "Logging in",
            "Inslag datum": "Date received",
            "Invoer verplicht!": "Input required!",
            "Klant": "Customer",
            "Lagenpick": "Layer picking",
            "Lengte": "Length",
            "Leverancier": "Supplier",
            "Losse stuks": "Separate items",
            "Lotcode": "Lot code",
            "Melding": "Note",
            "Mutatie": "Mutation",
            "Naam": "Name",
            "Nieuw wachtwoord": "New password",
            "OK": "OK",
            "Omschrijving": "Description",
            "Ontvangst": "Arrival",
            "Ontvangsten": "Arrivals",
            "Ontvangstbon geprint": "Arrivals printed!",
            "Order": "Order",
            "Ordernr afleveradres": "Order nr delivery address",
            "Ordernr klant": "Order nr customer",
			      "Orderreferentie": "Order reference",
            "Orders": "Orders",
            "Oud wachtwoord": "Old password",
            "Overzichten": "Overviews",
            "Pakbonnr leverancier": "Shipping list supplier",
            "Palletnr leverancier": "Pallet nr supplier",
            "Partij": "Batch",
            "Recall lijst": "Recall list",
            "Resultaat": "Result",
            "Sluiten": "Close",
            "SSCC": "SSCC",
            "SSCC inslag": "Inbound SSCC",
            "Status": "Status",
            "Status t/m": "Status to",
            "Status van": "Status from",
            "Stuks": "Pieces",
            "Stuks per pallet": "Pieces per pallet",
            "THT datum": "BBE date",
            "Totaal": "Total",
            "Type": "Type",
            "Uitloggen": "Log out",
            "Vandaag": "Today",
            "Verversen": "Refresh",
            "Volgnr": "Serial nr",
            "Volle pallet": "Full pallet",
            "Voorraad": "Stock",
            "Voorraad (de)blokkeren": "(Un)block stock",
            "Voorraad ID": "Stock ID",
            "Voorraad historie": "Stock history",
            "Voorraadmutaties": "Stock mutations",
            "Vrachtbrief afgemeld": "Shipping doc checked out",
            "Vrachtbrief geprint": "Shipping doc printed",
            "Vrijgegeven voor picking": "Release for picking",
            "Wachtwoord": "Password",
            "Wachtwoord herstellen": "Reset password",
            "Wachtwoord vergeten?": "Forgot password?",
            "Wachtwoord wijzigen": "Change password",
            "Warehouse limit dagen": "Warehouse limit days",
            "Welkom {naam}": "Welcome {{username}}", // LET OP: {{username}} wordt vervangen door de volledige naam van de gebruiker.
            "Wissen": "Delete",
            "Zoeken": "Search"
        })
    }
})();
(function () {
    "use strict";

    angular
        .module("App")
        .config(translateNL);
    
    translateNL.$inject = ["$translateProvider"];
    function translateNL($translateProvider) {
        $translateProvider.translations('FR', {
            "Actief": "Actif",
            "Acties": "Actions",
            "Afleveradres": "Adresse de livraison",
            "Afleverdatum": "Date de livraison",	
            "Afleverdatum t/m": "Date de livraison jusqu'au",
            "Afleverdatum van": "Date de livaison du",
            "Aflevernaam" : "Nom de l'adresse",
            "Afleverplaats": "Lieu de livraison",
            "Alleen met voorraad": "Uniquement en stock",
            "Annuleren": "Annuler",
            "Artikel": "Article",
            "Artikelen": "Articles",
            "Artikelomschrijving": "Description d'article",
            "Artikel verplicht": "Article requis",
            "Besteld": "Commandé",
            "Bevestigd": "Confirmé",
            "Bevestigd in magazijn": "Confirmé en magasin",
            "Bevestigd op kantoor": "Confirmé au bureau",
            "Blokkeren": "Bloquer",
            "Breedte": "Largeur",
            "Bundels": "colis",
            "Castelein WMS": "Castelein WMS",
            "Collipicken": "Ramassage de colli",
            "Datum": "Date",
            "Datum t/m": "Date jusqu'au",
            "Datum t/m niet gevuld": "Date jusqu'au est vide",
            "Datum t/m niet juist": "Date jsuqu'au erronée",
            "Datum van": "Date du",
            "Datum van niet gevuld": "Date du est vide",
            "Deblokkeren": "Débloquer",
            "Deels vrijgegeven": "En partie libéré",
            "Details": "Détails",
            "Documentnr": "No de document",
            "Doorgaan": "Continuer",
            "Download": "Télécharger",
            "DPU": "DPU",
            "DPU overzicht": "Relevé DPU",
            "Eancode": "Code EAN",
            "Emballage": "Emballage",
            "Er zijn geen gegevens gevonden die voldoen aan uw selectie.": "Aucun résultat ne correspond à votre recherche",
            "Externe partijcode": "Code de partie externe",
            "Filter": "Filtre",
            "Geannuleerd": "Annulé",
            "Geblokkeerd": "Bloqué",
            "Gebruikersnaam": "Nom d'utilisateur",
            "Geleverd": "Fourni",
            "Geselecteerd": "Sélectionné",
            "Gewicht": "Poids",
            "Herhaal wachtwoord": "Répéter le mot de passe",
            "Herhaal wachtwoord!": "Répéter le mot de passe!",
            "Het nieuwe wachtwoord is naar uw e-mailadres gestuurd.": "Le nouveau mot de passe est envoyé à votre adresse e-mail",
            "Hoogte": "Hauteur",
            "Initieel": "Initial",
            "Inloggen": "Se connecter",
            "Inslag datum": "Date de réception",
            "Invoer verplicht!": "Donnée obligatoire",
            "Klant": "Client",
            "Lagenpick": "Ramassage en couche",
            "Lengte": "Longueur",
            "Leverancier": "Fournisseur",
            "Losse stuks": "Pièces isolées",
            "Lotcode": "Lot",
            "Melding": "Notification",
            "Mutatie": "Mutation",
            "Naam": "Nom",
            "Nieuw wachtwoord": "Nouveau mot de passe",
            "OK": "OK",
            "Omschrijving": "Description",
            "Ontvangst": "Réception",
            "Ontvangsten": "Réceptions",
            "Ontvangstbon geprint": "Réception imprimée",
            "Order": "Commande",
            "Ordernr afleveradres": "No commande adresse de livraison",
            "Ordernr klant": "No commande client",
            "Orderreferentie": "Référence commande",
            "Orders": "Commandes",
            "Oud wachtwoord": "Ancien mot de passe",
            "Overzichten": "Relevés",
            "Pakbonnr leverancier": "Bon de livraison fournisseur",
            "Palletnr leverancier": "No de palette fournisseur",
            "Partij": "Partie",
            "Recall lijst": "Liste Recall",
            "Resultaat": "Résultat",
            "Sluiten": "Fermer",
            "SSCC": "SSCC",
            "SSCC inslag": "Réception SSCC ",
            "Status": "Statut",
            "Status t/m": "Statut jusqu'à",
            "Status van": "Statut de",
            "Stuks": "Pièces",
            "Stuks per pallet": "Pièces par palette",
            "THT datum": "Date DLUO",
            "Totaal": "Total",
            "Type": "Type",
            "Uitloggen": "Se déconnecter",
            "Vandaag": "Aujourd'hui",
            "Verversen": "Actualiser",
            "Volgnr": "no séquence",
            "Volle pallet": "Palette entière",
            "Voorraad": "Stock",
            "Voorraad (de)blokkeren": "Blocage de stock",
            "Voorraad ID": "Stock ID",
            "Voorraad historie": "Historique de stock",
            "Voorraadmutaties": "Mutations de stock",
            "Vrachtbrief afgemeld": "Document de transport validé ",
            "Vrachtbrief geprint": "Document de transport imprimé",
            "Vrijgegeven voor picking": "Libéré pour picking",
            "Wachtwoord": "Mot de passe",
            "Wachtwoord herstellen": "Rétablir le mot de passe",
            "Wachtwoord vergeten?": "Mot de passe oublié?",
            "Wachtwoord wijzigen": "Modifier le mot de passe",
            "Warehouse limit dagen": "NB de jours limite en stock",
            "Welkom {naam}": "Bienvenue {{username}}", // LET OP: {{username}} wordt vervangen door de volledige naam van de gebruiker.
            "Wissen": "Supprimer",
            "Zoeken": "Chercher"
        }); 
    }
})();
(function () {
    "use strict";

    angular
        .module("App")
        .config(translateNL);
    
    translateNL.$inject = ["$translateProvider"];
    function translateNL($translateProvider) {
        $translateProvider.translations('NL', {
            "Actief": "Actief",
            "Acties": "Acties",
            "Afleveradres": "Afleveradres",
            "Afleverdatum": "Afleverdatum",
            "Afleverdatum t/m": "Afleverdatum t/m",
            "Afleverdatum van": "Afleverdatum van",
            "Aflevernaam" : "Aflevernaam",
            "Afleverplaats": "Afleverplaats",
            "Alleen met voorraad": "Alleen met voorraad",
            "Annuleren": "Annuleren",
            "Artikel": "Artikel",
            "Artikelen": "Artikelen",
            "Artikelomschrijving": "Artikelomschrijving",
            "Artikel verplicht": "Artikel verplicht",
            "Besteld": "Besteld",
            "Bevestigd": "Bevestigd",
            "Bevestigd in magazijn": "Bevestigd in magazijn",
            "Bevestigd op kantoor": "Bevestigd op kantoor",
            "Blokkeren": "Blokkeren",
            "Breedte": "Breedte",
            "Bundels": "Bundels",
            "Castelein WMS": "Castelein WMS",
            "Collipicken": "Collipicken",
            "Datum": "Datum",
            "Datum t/m": "Datum t/m",
            "Datum t/m niet gevuld": "Datum t/m niet gevuld",
            "Datum t/m niet juist": "Datum t/m niet juist",
            "Datum van": "Datum van",
            "Datum van niet gevuld": "Datum van niet gevuld",
            "Deblokkeren": "Deblokkeren",
            "Deels vrijgegeven": "Deels vrijgegeven",
            "Details": "Details",
            "Documentnr": "Documentnr",
            "Doorgaan": "Doorgaan",
            "Download": "Download",
            "DPU": "DPU",
            "DPU overzicht": "DPU overzicht",
            "Eancode": "Eancode",
            "Emballage": "Emballage",
            "Er zijn geen gegevens gevonden die voldoen aan uw selectie.": "Er zijn geen gegevens gevonden die voldoen aan uw selectie.",
            "Externe partijcode": "Externe partijcode",
            "Filter": "Filter",
            "Geannuleerd": "Geannuleerd",
            "Geblokkeerd": "Geblokkeerd",
            "Gebruikersnaam": "Gebruikersnaam",
            "Geleverd": "Geleverd",
            "Geselecteerd": "Geselecteerd",
            "Gewicht": "Gewicht",
            "Herhaal wachtwoord": "Herhaal wachtwoord",
            "Herhaal wachtwoord!": "Herhaal wachtwoord!",
            "Het nieuwe wachtwoord is naar uw e-mailadres gestuurd.": "Het nieuwe wachtwoord is naar uw e-mailadres gestuurd.",
            "Hoogte": "Hoogte",
            "Initieel": "Initieel",
            "Inloggen": "Inloggen",
            "Inslag datum": "Inslag datum",
            "Invoer verplicht!": "Invoer verplicht!",
            "Klant": "Klant",
            "Lagenpick": "Lagenpick",
            "Lengte": "Lengte",
            "Leverancier": "Leverancier",
            "Losse stuks": "Losse stuks",
            "Lotcode": "Lotcode",
            "Melding": "Melding",
            "Mutatie": "Mutatie",
            "Naam": "Naam",
            "Nieuw wachtwoord": "Nieuw wachtwoord",
            "OK": "OK",
            "Omschrijving": "Omschrijving",
            "Ontvangst": "Ontvangst",
            "Ontvangsten": "Ontvangsten",
            "Ontvangstbon geprint": "Ontvangstbon geprint",
            "Order": "Order",
            "Ordernr afleveradres": "Ordernr afleveradres",
            "Ordernr klant": "Ordernr klant",
            "Orderreferentie": "Orderreferentie",
            "Orders": "Orders",
            "Oud wachtwoord": "Oud wachtwoord",
            "Overzichten": "Overzichten",
            "Pakbonnr leverancier": "Pakbonnr leverancier",
            "Palletnr leverancier": "Palletnr leverancier",
            "Partij": "Partij",
            "Recall lijst": "Recall lijst",
            "Resultaat": "Resultaat",
            "Sluiten": "Sluiten",
            "SSCC": "SSCC",
            "SSCC inslag": "SSCC inslag",
            "Status": "Status",
            "Status t/m": "Status t/m",
            "Status van": "Status van",
            "Stuks": "Stuks",
            "Stuks per pallet": "Stuks per pallet",
            "THT datum": "THT datum",
            "Totaal": "Totaal",
            "Type": "Type",
            "Uitloggen": "Uitloggen",
            "Vandaag": "Vandaag",
            "Verversen": "Verversen",
            "Volgnr": "Volgnr",
            "Volle pallet": "Volle pallet",
            "Voorraad": "Voorraad",
            "Voorraad (de)blokkeren": "Voorraad (de)blokkeren",
            "Voorraad ID": "Voorraad ID",
            "Voorraad historie": "Voorraad historie",
            "Voorraadmutaties": "Voorraadmutaties",
            "Vrachtbrief afgemeld": "Vrachtbrief afgemeld",
            "Vrachtbrief geprint": "Vrachtbrief geprint",
            "Vrijgegeven voor picking": "Vrijgegeven voor picking",
            "Wachtwoord": "Wachtwoord",
            "Wachtwoord herstellen": "Wachtwoord herstellen",
            "Wachtwoord vergeten?": "Wachtwoord vergeten?",
            "Wachtwoord wijzigen": "Wachtwoord wijzigen",
            "Warehouse limit dagen": "Warehouse limit dagen",
            "Welkom {naam}": "Welkom {{username}}", // LET OP: {{username}} wordt vervangen door de volledige naam van de gebruiker.
            "Wissen": "Wissen",
            "Zoeken": "Zoeken"
        })
        .preferredLanguage('NL')
    }
})();
(function () {
    "use strict";

    angular
        .module("App")
        .config(translateNL);
    
    translateNL.$inject = ["$translateProvider"];
    function translateNL($translateProvider) {
        $translateProvider.translations('', {
            "Actief": "",
            "Acties": "",
            "Afleveradres": "",
            "Afleverdatum": "",
            "Afleverdatum t/m": "",
            "Afleverdatum van": "",
            "Aflevernaam" : "",
            "Afleverplaats": "",
            "Alleen met voorraad": "",
            "Annuleren": "",
            "Artikel": "",
            "Artikelen": "",
            "Artikelomschrijving": "",
            "Artikel verplicht": "",
            "Besteld": "",
            "Bevestigd": "",
            "Bevestigd in magazijn": "",
            "Bevestigd op kantoor": "",
            "Blokkeren": "",
            "Breedte": "",
            "Bundels": "",
            "Castelein WMS": "",
            "Collipicken": "",
            "Datum": "",
            "Datum t/m": "",
            "Datum t/m niet gevuld": "",
            "Datum t/m niet juist": "",
            "Datum van": "",
            "Datum van niet gevuld": "",
            "Deblokkeren": "",
            "Deels vrijgegeven": "",
            "Details": "",
            "Documentnr": "",
            "Doorgaan": "",
            "Download": "",
            "DPU": "",
            "DPU overzicht": "",
            "Eancode": "",
            "Emballage": "",
            "Er zijn geen gegevens gevonden die voldoen aan uw selectie.": "",
            "Externe partijcode": "",
            "Filter": "",
            "Geannuleerd": "",
            "Geblokkeerd": "",
            "Gebruikersnaam": "",
            "Geleverd": "",
            "Geselecteerd": "",
            "Gewicht": "",
            "Herhaal wachtwoord": "",
            "Herhaal wachtwoord!": "",
            "Het nieuwe wachtwoord is naar uw e-mailadres gestuurd.": "",
            "Hoogte": "",
            "Initieel": "",
            "Inloggen": "",
            "Inslag datum": "",
            "Invoer verplicht!": "",
            "Klant": "",
            "Lengte": "",
            "Leverancier": "",
            "Losse stuks": "",
            "Lotcode": "",
            "Melding": "",
            "Mutatie": "",
            "Naam": "",
            "Nachtstand": "",
            "Nieuw wachtwoord": "",
            "OK": "",
            "Omschrijving": "",
            "Ontvangst": "",
            "Ontvangsten": "",
            "Ontvangstbon geprint": "",
            "Order": "",
            "Ordernr afleveradres": "",
            "Ordernr klant": "",
            "Orderreferentie": "",
            "Orders": "",
            "Oud wachtwoord": "",
            "Overzichten": "",
            "Pakbonnr leverancier": "",
            "Palletnr leverancier": "",
            "Partij": "",
            "Recall lijst": "",
            "Resultaat": "",
            "Sluiten": "",
            "SSCC": "",
            "SSCC inslag": "",
            "Status": "",
            "Status t/m": "",
            "Status van": "",
            "Stuks": "",
            "Stuks per pallet": "",
            "THT datum": "",
            "Totaal": "",
            "Type": "",
            "Uitloggen": "",
            "Vandaag": "",
            "Verversen": "",
            "Volgnr": "",
            "Volle pallet": "",
            "Voorraad": "",
            "Voorraad (de)blokkeren": "",
            "Voorraad ID": "",
            "Voorraad historie": "",
            "Voorraadmutaties": "",
            "Vrachtbrief afgemeld": "",
            "Vrachtbrief geprint": "",
            "Vrijgegeven voor picking": "",
            "Wachtwoord": "",
            "Wachtwoord herstellen": "",
            "Wachtwoord vergeten?": "",
            "Wachtwoord wijzigen": "",
            "Warehouse limit dagen": "",
            "Welkom {naam}": "", // LET OP: {{username}} wordt vervangen door de volledige naam van de gebruiker.
            "Wissen": "",
            "Zoeken": ""
        })
    }
})()
//# sourceMappingURL=app.bundle.min.js.map